import React from "react";
import { Link } from 'react-router';
import { ROUTES, SECTION_IDS } from '../../constants/routes';
import { CalendarView } from '../calendar/CalendarView';

export const KickCalendar = () => {
    return (
        <div id={SECTION_IDS.KICK_CALENDAR} className="text-center">
            <div className="section-title">
                <h2>Kalender</h2>
            </div>
            <div className="calendar">
                <CalendarView />

                <br/><br/><br/>
                <Link
                    to={ROUTES.CHALLENGER}
                    className="btn btn-custom btn-lg page-scroll"
                >
                    Anmeldung MiniChallenger
                </Link>
            </div>
        </div>
    );
};
